import { Typography } from '@stern-ui/ui';
import { Link } from '@tanstack/react-router';

import missingImg from '@/assets/error_missing.svg';
import { DefaultView } from '@/layout/DefaultView';

export const Sorry = () => {
	return (
		<DefaultView isFixedHeight={true}>
			<main>
				<div className='h-full overflow-auto pb-16 md:pb-0 md:h-auto flex items-center justify-center'>
					<div className='text-center'>
						<img alt='Missing icon' src={missingImg} className='inline-block mb-8' />
						<Typography variant='main' className='text-primaryTextDark pb-8'>
							Sorry, we couldn’t find that page
						</Typography>
						<Typography variant='bodyBig' className='pb-4'>
							Please double check your link and try again.
						</Typography>
						<Typography variant='bodyBig'>
							If you require assistance, please <Link to='/help'>contact us</Link>.
						</Typography>
					</div>
				</div>
			</main>
		</DefaultView>
	);
};
